export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionar exportación"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de exportaciones"])},
          "not_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aún no tiene contenedores asignados"])},
          "destroy_button_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "destroy_button_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar exportación"])},
          "destroy_button_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Está seguro de eliminar la exportación?"])},
          "destroy_button_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "edit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])},
          "no_exportation_attachments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No hay archivos adjuntos"])},
          "exportation_report_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Generar reporte de exportación"])}
        }
      }
    }
  })
}